import { Modal } from 'react-responsive-modal'
import styled from 'styled-components'
import { SECONDARY_GREEN_01 } from 'bd-web-components/src/utils/dash-colors'

export const StyledModal = styled(Modal)`
  &.react-responsive-modal-modal {
    width: 450px;
    border-radius: 8px;
    padding: 24px;
  }
`

export const TitleAndIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
`

export const TitleAndSubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const TitleText = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0;
`

export const SubTitleText = styled.p`
  font-size: 14px;
  color: #666;
  margin: 5px 0 0 0;
`

export const CloseButtonIcon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
`

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`

export const TitleAndValueDataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
`

export const DataTitleText = styled.span`
  font-size: 14px;
  color: #666;
`

export const DataValueText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
`

export const CancelButton = styled.button`
  flex: 1;
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ConfirmButton = styled.button`
  flex: 1;
  background-color: ${SECONDARY_GREEN_01};
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
